import ProductCategoryDetailPanel from './productCategoryDetailPanel.container';

export default ProductCategoryDetailPanel;